import { render, staticRenderFns } from "./AffiliateList.vue?vue&type=template&id=3c8bb7c7"
import script from "./AffiliateList.vue?vue&type=script&lang=js"
export * from "./AffiliateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports